<template>
  <v-navigation-drawer permanent>
    <img src="logo2.png" alt="Company Logo" :style="logoStyle" />
    <v-divider class="mt-4"></v-divider>
    <v-list>
      <!-- <v-list-item @click="navigateTo('/')" :class="{ 'active-item': activeItem === '/' }">
        <v-list-item
          prepend-icon="mdi-view-dashboard"
          title="Dashboard"
          class="v-list-item-title"
        ></v-list-item>
      </v-list-item> -->
      <v-list-item @click="navigateTo('/brands')" :class="{ 'active-item': activeItem === '/brands' }" class="v-list-item-title">
        <v-list-item
          prepend-icon="mdi-comment-question-outline"
          title="Brands"
          class="custom-list-item"
        ></v-list-item>
      </v-list-item>
      <v-list-item @click="navigateTo('/categories')" :class="{ 'active-item': activeItem === '/categories' }" class="v-list-item-title">
        <v-list-item prepend-icon="mdi-plus" title="Categories" class="custom-list-item"></v-list-item>
      </v-list-item>

      <v-list-item @click="navigateTo('/medicines')" :class="{ 'active-item': activeItem === '/medicines' }" class="v-list-item-title">
          <v-list-item
          prepend-icon="mdi-hospital-box"
          title="Medicines"
        ></v-list-item>
      </v-list-item>

      <v-list-item @click="navigateTo('/blogs')" :class="{ 'active-item': activeItem === '/blogs' }" class="v-list-item-title">
        <v-list-item
          prepend-icon="mdi-post-outline"
          title="Blogs"
          class="custom-list-item"
        ></v-list-item>
      </v-list-item>

      <v-list-item @click="navigateTo('/inquiry')" :class="{ 'active-item': activeItem === '/inquiry' }" class="v-list-item-title">
        <v-list-item
          prepend-icon="mdi-comment-question-outline"
          title="Inquiries"
          class="custom-list-item"
        ></v-list-item>
      </v-list-item>

      <v-list-item @click="navigateTo('/distributor')" :class="{ 'active-item': activeItem === '/distributor' }" class="v-list-item-title">
        <v-list-item
          prepend-icon="mdi-comment-question-outline"
          title="Distributors"
          class="custom-list-item"
        ></v-list-item>
      </v-list-item>
      
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data(){
    return{
      activeItem: null,
    }
  },
  mounted() {
    this.activeItem = this.$route.path; 
  },
  computed: {
    logoStyle() {
      return {
        maxWidth: '100%',
        height: '41px',
        paddingLeft: '62px',
        position: 'relative',
        top: '10px',
        width: '186px',
        height: '60px'
      };
    }
  },
  methods: {
    navigateTo(routePath) {
      this.activeItem = routePath;
      this.$router.push(routePath);
    },
  },
};
</script>

<style scoped>
.active-item {
  background-color: #0277BD; 
  color: white; 
}

.v-list-item__content .v-list-item-title{
  font-weight: 900 !important;
}
</style>
